<template>
  <div class="h-full flex flex-col">
    <loader :loading="loading" :backdrop="true" />
    <div class="mb-4">
      <p class="font-bold">report format</p>
      <span class="form-hint">your download will begin automatically after clicking the export to excel button</span>
    </div>
    <div class="flex-1 flex-col overflow-auto">
      <List
        resource="previewTrainingPhrasesReport"
        :fields="fields"
        :pageSize="18"
        trackBy="intent_response_id"
        :search="true"
        :requestParams="{sortField: '', direction: '', language: this.language?.value}"
        :onReload="this.language?.value"
        searchButton
      >
        <template v-slot:message>
          <div class="w-1/3">
            <Dropdown
              trackBy="label"
              label="label"
              :options="[{label: 'english', value: 'en'}, {label: 'spanish', value: 'es'}]"
              :value="language"
              @input="setLanguage"
              objectMode
              noClear
            />
          </div>
        </template>
      </List>
    </div>
    <modal-footer :footer="footer" :primary="onDownload" :tertiary="cancel"  />
  </div>
</template>

<script>
import ModalNavigation from '@/mixins/ModalNavigation'
import ModalFooter from '@/components/ui/modals/ModalFooter'
import List from '@/components/digital_human/List'
import NotifyMixin from '@/mixins/NotifyMixin'
import Loader from '@/components/ui/Loader'
import Dropdown from '@/components/ui/Dropdown'
import EventBus from "@/utils/EventBus"

const addsLineBreak = (value) => {
  if(!value) return ''
  let data = '';
  value.forEach((phrase) => {
      data += `${phrase}<br>` ;
  });
  return data;
}

export default {
  name: 'TrainingPhrasesReport',
  components: { Loader, ModalFooter, List, Dropdown },
  mixins: [ModalNavigation, NotifyMixin],
   data() {
    return {
      language: {label: 'english', value: 'en'},
      loading: false,
      footer: {
        primaryButton: 'export to excel',
        tertiaryButton: 'cancel',
      },
      fields: [
        {
          name: 'intentName',
          title: 'intent name',
          sortField: 'intentName',
          dataClass: 'flex'
        },
        {
          name: 'inputContext',
          title: 'input context',
          sortField: 'inputContext',
          formatter: addsLineBreak,
        },
        {
          name: 'outputContext',
          title: 'output context',
          sortField: 'outputContext',
          formatter: addsLineBreak,
        },
        {
          name: 'trainingPhrases',
          title: 'training phrases',
          formatter: addsLineBreak,
        },
      ],
      fitleExtention: '',
    }
  },
  methods: {
    setLanguage(value) {
      this.language = null;
      if(!value) return
      this.language = value;
    },
    download(extention) {
        this.fitleExtention = extention;
        if (this.fitleExtention !== '')
          EventBus.emit('show-modal-download', { title: 'Download PDF', downloadStarted: 'download started'});
    },
    downloadProcess(data, extentionFile) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `training-phrases-report.${extentionFile}`);
      document.body.appendChild(link);
      link.click();
    },
    generateExcelReport() {
      this.$dhDataProvider.get('trainingPhrasesReportPdf', {
        language: this.language.value,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'Content-disposition': 'attachment',
          'format_file': 'xlsx'
        }})
        .then(response => {
          if (this.fitleExtention.trim() !== '') {
            this.fitleExtention = ''
            this.downloadProcess(response, 'xlsx');
          }
        })
        .catch((error) => this.notifyError(error))
        .finally(() => this.hideDownloadIndicator())
    },
    onDownload() {
      this.download('xlsx')
    },
    cancel() {
      this.redirect('responses.index')
    },
  },
  validations: {
    responseText: 'required',
  },
  created() {
    this.initValidator()
  },
  mounted() {
    EventBus.on('download-pdf', () => {
      switch (this.fitleExtention) {
        case 'xlsx':
          this.generateExcelReport()
          break;
        default:
          this.fitleExtention = ''
          break;
      }
    })
  }
}
</script>
<style scoped>
.form {
  width: 55%;
}

.label-container {
  width: 53%;
}

</style>
